import { Cursors, DRAG, DRAG_END, DRAG_START } from './../../constants';
import { canDrag } from './canDrag';
export class ConnectionResizeTool {
    constructor(toolService) {
        this.toolService = toolService;
        this.type = 'ConnectionResizeTool';
    }
    tryActivate(_p, meta) {
        const toolService = this.toolService;
        const item = toolService.hoveredItem;
        const editable = item && item.pointsEditable && item.pointsEditable();
        // Try to activate if we have a selected connection with a resize adorner
        const isActive = editable !== false &&
            item && item.path && item.isSelected &&
            item.resizeAdorner &&
            item.resizeAdorner._hitTest(_p) !== null &&
            !meta.ctrlKey;
        if (isActive) {
            this._c = item;
            // Store the handle from hit test to avoid searching again in start()
            this.handle = item.resizeAdorner._hitTest(_p);
        }
        return !!isActive;
    }
    start(point, meta, nativeEvent) {
        const connection = this._c;
        const adorner = connection.resizeAdorner;
        // Check canDrag
        const canDragResult = canDrag(connection);
        // Check DRAG_START trigger
        const triggerResult = this.toolService.diagram.trigger(DRAG_START, { shapes: [], connections: [connection], point, meta, nativeEvent });
        const finalCondition = canDragResult && adorner && this.handle && !triggerResult;
        // Handle is already set in tryActivate()
        if (finalCondition) {
            adorner.start(point);
        }
        else {
            this.toolService.startPoint = point;
            this.toolService.end(point, meta, nativeEvent);
        }
    }
    move(point, meta, nativeEvent) {
        const adorner = this._c.resizeAdorner;
        if (canDrag(this._c) && adorner && this.handle) {
            adorner.move(this.handle, point);
            this.toolService.diagram.trigger(DRAG, { shapes: [], connections: [this._c], point, meta, nativeEvent });
            return true;
        }
    }
    end(point, meta, nativeEvent) {
        const connection = this._c;
        const adorner = connection.resizeAdorner;
        const toolService = this.toolService;
        const diagram = toolService.diagram;
        if (adorner) {
            if (canDrag(connection)) {
                const unit = adorner.stop(point);
                if (unit && !diagram.trigger(DRAG_END, { shapes: [], connections: [connection], point, meta, nativeEvent })) {
                    diagram.undoRedoService.add(unit, false);
                    connection.updateModel();
                    diagram._syncConnectionChanges();
                }
                else if (unit) {
                    unit.undo();
                }
                else {
                    adorner.cancel();
                }
            }
        }
    }
    getCursor(_point) {
        const connection = this._c;
        if (connection && connection.resizeAdorner && this.handle) {
            return connection.resizeAdorner._getCursor(this.handle.point);
        }
        return Cursors.move;
    }
}
